export function getEnvironmentName(environment = process.env) {
  return (environment && environment.VUE_APP_ENV_NAME ? environment.VUE_APP_ENV_NAME : "").toLowerCase();
}

export function isProduction(environment = process.env) {
  return getEnvironmentName(environment) === "production";
}
